import axios from "axios";

const requestPointList = parameter => {
  return axios.post(
    `${process.env.VUE_APP_APIURL}/api/app/point/${parameter.type}/list`,
    parameter
  );
};

const requestPointPaybackList = parameter => {
  return axios.post(
    `${process.env.VUE_APP_APIURL}/api/app/point/${parameter.type}/payback-list`,
    parameter
  );
};

const requestPointPayback = parameter => {
  return axios.post(
    `${process.env.VUE_APP_APIURL}/api/app/point/${parameter.type}/payback-point`,
    parameter
  );
};

export { requestPointList, requestPointPaybackList, requestPointPayback };
